import sleep from "sleep-promise";

class Clock {
    interval;
    tick;
    _stopped;
    _lastTickTime;

    constructor(tick, interval) {
        this.tick = tick;
        this.interval = interval;
    }

    async start() {
        this._stopped = false;
        this._lastTickTime = Date.now();
        while(!this._stopped) {
            const currentTime = Date.now();
            await this.tick(currentTime - this._lastTickTime);
            this._lastTickTime = currentTime;
            await sleep(this.interval);
        }
    }

    stop() {
        this._stopped = true;
    }
}

export default Clock;
